import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Firestore, doc, getDoc, setDoc, onSnapshot } from '@angular/fire/firestore';
import { UserProfile, UserProfileData } from '../classes/UserProfile';

@Injectable({
  providedIn: 'root'
})
export class UserProfileService {
  private fireDb = inject(Firestore);
  private readonly collectionPath = 'users';

  constructor() {}

  private userDoc(userId: string) {
    return doc(this.fireDb, `${this.collectionPath}/${userId}`);
  }

  async getUser(userId: string): Promise<UserProfile | undefined> {
    try {
      const ref = this.userDoc(userId);
      const snap = await getDoc(ref);

      if (!snap.exists()) {
        console.warn(`UserProfile not found for userId: ${userId}`);
        return undefined;
      }

      const data = snap.data();
      return UserProfile.initFromObject(data as UserProfileData);
    } catch (error) {
      console.error('Firestore error while getting UserProfile:', userId, error);
      return undefined;
    }
  }

  async saveUser(user: UserProfile): Promise<boolean> {
    try {
      const ref = this.userDoc(user.id);
      await setDoc(ref, user.getDataObject(), { merge: true });
      return true;
    } catch (error) {
      console.error('Firestore error while writing UserProfile:', user.id, error);
      return false;
    }
  }

  /** Live-Stream eines Users */
  watchUser$(userId: string): Observable<UserProfile | undefined> {
    const ref = this.userDoc(userId);

    return new Observable((subscriber) => {
      const unsubscribe = onSnapshot(
        ref,
        (snap) => {
          if (!snap.exists()) {
            subscriber.next(undefined);
            return;
          }
          try {
            subscriber.next(UserProfile.initFromObject(snap.data() as UserProfileData));
          } catch (e) {
            console.error('Invalid UserProfileData from Firestore', e, snap.data());
            subscriber.next(undefined);
          }
        },
        (error) => subscriber.error(error)
      );

      return () => unsubscribe();
    });
  }

}
